<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <!-- <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector> -->
    </vdr-ab-left>
    <vdr-ab-right>
      <!-- <vdr-action-bar-items [locationId]="'alert-list'"></vdr-action-bar-items> -->
      <!-- <a class="btn btn-primary" [routerLink]="['./', 'create']">
        <clr-icon shape="plus"></clr-icon>
        Create
      </a> -->
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2
  id="alert-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="alert-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-column
    id="code"
    [heading]="'common.code' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      {{ item.code }}
    </ng-template>
  </vdr-dt2-column>

  <!-- <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/email-templates', item.code]"
      >
        <span>
          {{ item.code }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column> -->

  <vdr-dt2-column
    id="id"
    [heading]="'common.customer' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      <a
        *ngIf="item.customer"
        class="button-ghost"
        [routerLink]="['/extensions/ui-customer', item.customerId]"
      >
        <span>
          {{ item.customer.firstName }} {{ item.customer.lastName }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>

      <div *ngIf="!item.customer">*</div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="id"
    [heading]="'customer.email-address' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      {{
        item.emailAddress
          ? item.emailAddress
          : item.customer ? item.customer.emailAddress : "*"
      }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-item="item">
      {{ item.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-item="item">
      {{ item.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
